module.exports = __webpack_public_path__ + "static/media/main idea.813a8856.mp3";